import axios from 'axios';
import { getApiBase } from '../config/api';
import { buildJsonBody } from '../utils/encryption';

const API = getApiBase();

/** POST /auth/signup — creates pending user, sends 6-digit verification code */
export async function signup({ user_email, user_password }) {
  const body = buildJsonBody({ user_email, user_password });
  const { data } = await axios.post(`${API}/auth/signup`, body);
  return data;
}

/** POST /auth/verify-code — confirm 6-digit code, returns JWT tokens */
export async function verifyCode({ user_email, verification_code }) {
  const body = buildJsonBody({ user_email, verification_code });
  const { data } = await axios.post(`${API}/auth/verify-code`, body);
  return data;
}

/** POST /auth/resend-code — resend a fresh 6-digit verification code */
export async function resendCode(user_email) {
  const body = buildJsonBody({ user_email });
  const { data } = await axios.post(`${API}/auth/resend-code`, body);
  return data;
}

/** POST /auth/login */
export async function login({ user_email, user_password }) {
  const body = buildJsonBody({ user_email, user_password });
  const { data } = await axios.post(`${API}/auth/login`, body);
  return data;
}

/** POST /auth/refresh — exchange refresh token for new access token */
export async function refreshAccessToken(refresh_token) {
  const body = buildJsonBody({ refresh_token });
  const { data } = await axios.post(`${API}/auth/refresh`, body);
  return data;
}

/** GET /auth/me — authenticated user profile */
export async function getMe(accessToken) {
  const { data } = await axios.get(`${API}/auth/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return data;
}

/** POST /auth/change-password — authenticated */
export async function changePassword({ current_password, new_password }, accessToken) {
  const body = buildJsonBody({ current_password, new_password });
  const { data } = await axios.post(`${API}/auth/change-password`, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return data;
}

/** POST /auth/forgot-password */
export async function forgotPassword(user_email) {
  const body = buildJsonBody({ user_email });
  const { data } = await axios.post(`${API}/auth/forgot-password`, body);
  return data;
}

/** GET /auth/confirm-email?token=<jwt> */
export async function confirmEmail(token) {
  const { data } = await axios.get(`${API}/auth/confirm-email`, {
    params: { token },
  });
  return data;
}
